/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from "react";
import { styled, useTheme } from "@mui/material/styles";
import {
  CssBaseline,
  Drawer as MuiDrawer,
  AppBar as MuiAppBar,
  Toolbar,
  List,
  IconButton,
  Typography,
  Avatar,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
  Box,
  useMediaQuery,
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import Logout from "@mui/icons-material/Logout";
import HelpIcon from "@mui/icons-material/Help";
import CachedIcon from "@mui/icons-material/Cached";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { populateServiceData } from "src/general_helpers/initDataLoad";
import { AuthContext } from "src/context/AuthContext";
import Swal from "sweetalert2";
import { types } from "src/context/types";
import { SimpleDialogComponent } from "src/general_components/SimpleDialogComponent";
import { MiPerfilForm } from "src/general_components/MiPerfilForm";
import { SnackbarMessenger } from "src/general_components/SnackbarMessenger";
import { SideMenu } from "./SideMenu2";
import TheContent from "./TheContent";
import { appName } from "src/configs/config";
import SearchComponentHeader from "src/general_components/SearchComponentHeader";
import AIChatWidget from "src/general_components/AIChatWidget";

import "src/services/styles/sweetAlert.css";
import ButtonConfig from "src/general_components/ButtonConfig";
import ModalConfig from "src/general_components/ModalConfig";
import { ThemeContext } from "src/context/ThemeContext";

const drawerWidth = 272;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "isDesktop",
})(({ theme, open, isDesktop }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),

  ...(isDesktop &&
    open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
}));

const DrawerDesktop = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "fullyHidden",
})(({ theme, open, fullyHidden }) => ({
  "& .MuiDrawer-paper": fullyHidden
    ? {
        position: "sticky",
        top: 0,
        height: "100vh",
        whiteSpace: "nowrap",
        width: 0,
        transition: theme.transitions.create("width", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        boxSizing: "border-box",
        overflowX: "hidden",
        overflowY: "auto",
      }
    : {
        position: "sticky",
        top: 0,
        height: "100vh",
        whiteSpace: "nowrap",
        width: open ? drawerWidth : theme.spacing(9),
        transition: theme.transitions.create("width", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        boxSizing: "border-box",
        overflowX: "hidden",
        overflowY: "auto",
      },
}));

const DashboardContent = () => {
  const { dispatch } = useContext(AuthContext);

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const [modalState, setModalState] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [userSelect, setUserSelect] = useState({});
  const [createButton, setCreateButton] = useState(false);

  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarVisible, setSnackbarVisible] = useState(false);

  const localStorageOpen = localStorage.getItem("openSideMenu");
  const [open, setOpen] = useState(localStorageOpen === "false" ? false : true);

  const [fullyHidden, setFullyHidden] = useState(false);

  const [mobileOpen, setMobileOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [aiEnabled, setAiEnabled] = useState(() => localStorage.getItem('aiWidgetEnabled') !== 'false');
  const [aiMode, setAiMode] = useState(() => localStorage.getItem('aiWidgetMode') || 'floating');

  const handleAiEnabledChange = (val) => {
    setAiEnabled(val);
    localStorage.setItem('aiWidgetEnabled', val);
  };
  const handleAiModeChange = (val) => {
    setAiMode(val);
    localStorage.setItem('aiWidgetMode', val);
  };

  if (localStorageOpen === null) {
    localStorage.setItem("openSideMenu", true);
  }

  const toggleDrawer = () => {
    if (!isDesktop) {
      setMobileOpen((prev) => !prev);
      return;
    }

    if (fullyHidden) {
      setFullyHidden(false);
    }

    const newState = !open;
    setOpen(newState);
    localStorage.setItem("openSideMenu", newState);
  };

  const handleToggleFullyHidden = () => {
    if (!isDesktop) return;
    setFullyHidden(!fullyHidden);
  };

  const handleOpenModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const nombreApellidoUsuario = JSON.parse(
    localStorage.getItem("siam-user-data")
  );

  const ownersLocalStorage = JSON.parse(localStorage.getItem("clientData"));
  const owner = ownersLocalStorage?.owner_descripcion;

  const [anchorEl, setAnchorEl] = useState(null);
  const openTooltip = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const rechargeCache = () => {
    localStorage.setItem("estadoPeticionModelos", "false");
    populateServiceData();
  };

  const Logouts = () => {
    Swal.fire({
      title: "Desea cerrar sesion?",
      showDenyButton: true,
      confirmButtonText: `Si`,
      denyButtonText: `No`,
      customClass: {
        container: "my-swal-delete",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch({
          type: types.logout,
          payload: {},
        });
        localStorage.clear();
      }
    });
  };

  const toggleModal = () => {
    setModalState(!modalState);
    setCreateButton(!createButton);
    setUserSelect({});
  };

  useEffect(() => {
    if (!createButton) {
      setUserSelect({});
    }
  }, [createButton]);

  const backgroundDrawer = theme.backgroundDrawer?.default || "#0f172a";

  const dialogChild = (
    <MiPerfilForm
      data={userSelect}
      setButtonClicked={setButtonClicked}
      setCreateButton={toggleModal}
      setUserSelect={setUserSelect}
      setSnackbarVisible={setSnackbarVisible}
      setMessage={setMessage}
      setSeverity={setSeverity}
    />
  );

  const drawerContent = (
    <>
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: backgroundDrawer,
          px: 1.5,
          minHeight: "56px !important",
          borderBottom: "1px solid rgba(255,255,255,0.06)",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: "#FFFFFF",
            fontFamily: '"Public Sans", sans-serif',
            fontSize: "0.875rem",
            fontWeight: 600,
            letterSpacing: "0.02em",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            flexGrow: 1,
          }}
        >
          {appName}
        </Typography>

        <IconButton onClick={toggleDrawer} size="small" sx={{ color: "rgba(255,255,255,0.55)", "&:hover": { color: "#fff", bgcolor: "rgba(255,255,255,0.08)" } }}>
          <MenuOpenIcon fontSize="small" />
        </IconButton>
      </Toolbar>

      <List
        component="nav"
        sx={{
          height: "100%",
          overflowY: "auto",
          "&::-webkit-scrollbar": { width: "3px" },
          "&::-webkit-scrollbar-thumb": {
            borderRadius: "3px",
            background: "gray",
          },
          maxHeight: "calc(100vh - 56px)",
        }}
      >
        <SideMenu
          open={isDesktop ? open : true}
          isMobile={!isDesktop}
          drawerVariant={!isDesktop ? "dark" : "default"}
          Logouts={Logouts}
          onNavigate={() => setMobileOpen(false)}
        />
      </List>
    </>
  );

  return (
    <Box sx={{ display: "flex", width: "100%" }}>
      <CssBaseline />

      {/* APPBAR */}
      <AppBar position="fixed" open={open && !fullyHidden} isDesktop={isDesktop}>
        <Toolbar
          sx={{
            pr: 1,
            minHeight: "56px !important",
            display: "flex",
            alignItems: "center",
            gap: 1,
            justifyContent: "flex-start",
          }}
        >
          {/* LEFT */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              sx={{
                ...(isDesktop &&
                  open &&
                  !fullyHidden && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>

            {isDesktop && (
              <Tooltip title={fullyHidden ? "Mostrar Menú" : "Ocultar Menú"}>
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="toggle menu"
                  onClick={handleToggleFullyHidden}
                >
                  {fullyHidden ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
              </Tooltip>
            )}
          </Box>

          {/* SEARCH INLINE */}
          <Box
            sx={{
              flexGrow: 1,
              maxWidth: { xs: "190px", sm: "520px" },
              minWidth: { xs: "140px", sm: "260px" },
              transform: { xs: "scale(0.88)", sm: "none" },
              transformOrigin: "left center",
              mt: { xs: "-2px", sm: 0 },
              position: "relative",
              zIndex: 9999,
              pointerEvents: "auto",
            }}
          >
            <SearchComponentHeader />
          </Box>

          {/* RIGHT */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              ml: "auto",
              flexShrink: 0,
              position: "relative",
              zIndex: 1,
            }}
          >
            <ButtonConfig handleClick={handleOpenModal} />

            <ThemeContext.Consumer>
              {({ handleThemeChange, handleColorChange }) => (
                <ModalConfig
                  open={isModalOpen}
                  onClose={handleOpenModal}
                  onThemeChange={handleThemeChange}
                  onColorChange={handleColorChange}
                  aiEnabled={aiEnabled}
                  onAiEnabledChange={handleAiEnabledChange}
                  aiMode={aiMode}
                  onAiModeChange={handleAiModeChange}
                />
              )}
            </ThemeContext.Consumer>

            <Tooltip title="Perfil">
              <IconButton
                onClick={handleClick}
                size="small"
                aria-controls={openTooltip ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openTooltip ? "true" : undefined}
              >
                <Avatar sx={{ width: 30, height: 30 }} />
              </IconButton>
            </Tooltip>

            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={openTooltip}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem>
                <ListItemIcon>
                  <PersonIcon fontSize="small" style={{ color: "#3c4b64" }} />
                </ListItemIcon>

                <Typography
                  variant="caption"
                  sx={{ fontWeight: "bold", fontSize: 13, color: "#3c4b64" }}
                >
                  {nombreApellidoUsuario?.nombre +
                    ", " +
                    nombreApellidoUsuario?.apellido}
                </Typography>
              </MenuItem>

              {owner && (
                <MenuItem>
                  <ListItemIcon>
                    <BusinessIcon
                      fontSize="small"
                      style={{ color: "#3c4b64" }}
                    />
                  </ListItemIcon>

                  <Typography
                    variant="caption"
                    sx={{ fontWeight: "bold", fontSize: 13, color: "#3c4b64" }}
                  >
                    {owner}
                  </Typography>
                </MenuItem>
              )}

              <Divider>
                <Typography variant="caption" sx={{ fontSize: 10 }}>
                  Acciones
                </Typography>
              </Divider>

              <MenuItem onClick={toggleModal}>
                <ListItemIcon>
                  <PersonIcon fontSize="small" />
                </ListItemIcon>
                Mi perfil
              </MenuItem>

              <MenuItem component="a" href="/help">
                <ListItemIcon>
                  <HelpIcon fontSize="small" />
                </ListItemIcon>
                Help
              </MenuItem>

              <MenuItem onClick={rechargeCache}>
                <ListItemIcon>
                  <CachedIcon fontSize="small" />
                </ListItemIcon>
                Actualizar Cache
              </MenuItem>

              <Divider />

              <MenuItem onClick={Logouts}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* DRAWER DESKTOP */}
      {isDesktop && (
        <DrawerDesktop variant="permanent" open={open} fullyHidden={fullyHidden}>
          {drawerContent}
        </DrawerDesktop>
      )}

      {/* DRAWER MOBILE */}
      {!isDesktop && (
        <MuiDrawer
          variant="temporary"
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          ModalProps={{ keepMounted: true }}
          sx={{
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              bgcolor: backgroundDrawer,
              color: "#fff",
            },
          }}
        >
          {drawerContent}
        </MuiDrawer>
      )}

      {/* MAIN CONTENT */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: "100vh",
          width: "100%",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
          bgcolor: "background.paper",
        }}
      >
        <Toolbar />

        <Box sx={{ flexGrow: 1, px: { xs: 1.5, sm: 2, md: 3 }, py: { xs: 1.5, sm: 2 } }}>
          <TheContent />
        </Box>

        <SimpleDialogComponent
          open={modalState}
          modalName={"Mi Perfil"}
          child={dialogChild}
          handleClose={toggleModal}
          buttonEnviar={false}
          buttonCancelar={false}
          maxWidth="md"
        />

        <SnackbarMessenger
          open={snackbarVisible}
          message={message}
          severity={severity}
          close={() => setSnackbarVisible(false)}
        />
      </Box>

      <AIChatWidget enabled={aiEnabled} mode={aiMode} />
    </Box>
  );
};

export default React.memo(DashboardContent);
